import React from 'react'
import Navbar from '../components/navbar'
import { Link } from 'react-router-dom'

import bg from '../assets/images/bg3.png'
import app from '../assets/images/app.png'
import play from '../assets/images/play.png'
import phone from '../assets/images/phone/2.png'
import AboutOne from '../components/about-one'
import AboutTwo from '../components/about-two'
import Screenshot from '../components/screenshot'
import Download from '../components/download'
import Footer from '../components/footer'
import FeaturesTwo from '../components/features-two'
import { TypeAnimation } from 'react-type-animation'

export default function IndexOne() {
  return (
    <>
        
        <Navbar navLight={false} playBtn={false} bgLight={false} navCenter={true}/>

        <section className="relative overflow-hidden md:py-36 py-24 bg-slate-50/50 dark:bg-slate-800/20 bg-no-repeat bg-center bg-cover" id="home" style={{backgroundImage:`url(${bg})`}}>
            <div className="container relative px-8 sm:px-10 md:px-14 lg:px-16">
                <div className="grid md:grid-cols-2 grid-cols-1 items-center mt-6 gap-[30px] relative">
                    <div className="md:me-6">
                        
                   <h4 className="lg:leading-normal leading-normal text-4xl lg:text-[54px] mb-5">
                    La Nueva Experiencia Club333
                    <br />

                    <span className="block lg:hidden font-bold">
                        En una sola APP
                    </span>

                    <span className="hidden lg:inline-block">
                        <TypeAnimation
                        sequence={[
                            "En una sola APP",
                            1000,
                            "Consulta tu Saldo",
                            1000,
                            "Recarga tu cuenta",
                            1000,
                        ]}
                        wrapper="span"
                        speed={20}
                        repeat={Infinity}
                        className="typewrite font-bold"
                        cursor={false}
                        />
                    </span>
                    </h4>
                        <p className="text-slate-400 text-lg max-w-xl">Administra tu cuenta, utiliza tu tarjeta digital NFC y disfruta una experiencia más rápida, cómoda y segura.</p>
                    
                        <div className="mt-6">
                            <Link to="https://apps.apple.com/mx/app/club-333/id6773431030"><img src={app} className="h-12 inline-block m-1" alt=""/></Link>
                            <Link to="https://play.google.com/store/apps/details?id=mx.club333.club333"><img src={play} className="h-12 inline-block m-1" alt=""/></Link>
                        </div>
                    </div>

                    <div className="relative">
                        <img src={phone} className="mx-auto w-80 rotate-12 relative z-2" alt=""/>
                        <div className="overflow-hidden absolute md:size-[500px] size-[400px] bg-gradient-to-tl to-red-500/20 via-red-500/70 from-red-500 bottom-1/2 translate-y-1/2 md:start-0 start-1/2 ltr:md:translate-x-0 ltr:-translate-x-1/2 rtl:md:translate-x-0 rtl:translate-x-1/2 z-1 shadow-md shadow-red-500/10 rounded-full"></div>

                        <div className="overflow-hidden after:content-[''] after:absolute after:size-16 after:bg-red-500/20 after:top-0 after:end-6 after:z-1 after:rounded-lg after:animate-[spin_10s_linear_infinite]"></div>
                    </div>
                </div>
            </div>
        </section>

      
        <section className="relative md:py-24 py-16" id="features">
            <div className="container relative">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">Funciones</h6>
                    <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">Todo lo que necesitas en Club333</h4>
    
                    <p className="text-slate-400 max-w-xl mx-auto">Administra tu cuenta, consulta saldos y disfruta una experiencia más rápida, cómoda y segura desde tu celular.</p>
                </div>
    
                <FeaturesTwo/>
            </div>
    
            <div className="container relative md:mt-24 mt-16">
                <AboutOne/>
            </div>
    
            <div className="container relative md:mt-24 mt-16">
                <AboutTwo/>
            </div>
        </section>

        <section className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20" id="screenshot">
            <div className="container relative">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">Diseñada para Ti</h6>
                    <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">Vive la Experiencia</h4>

                    <p className="text-slate-400 max-w-xl mx-auto">Descubre una interfaz diseñada para brindarte acceso rápido, cómodo y seguro a todas las funciones de Club333.</p>
                </div>
                <Screenshot/>
            </div>
        </section>

        <section className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20" id="download">
            <Download/>
        </section>
        
        <Footer/>
        
    </>
  )
}
